<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="600px"
    :close-on-click-modal="false"
    destroy-on-close
    class="app-main-inner edi-selector-dialog"
  >
    <div class="app-main-inner-row">
      <el-button type="primary" @click="toSelectRow">{{ $t('CargoMsg.Cargo_Select') }}</el-button>
    </div>
    <div class="app-main-inner-row row-grid-dialog" style="height: 350px;padding-bottom: 20px;">

      <cargo-ag-grid
        :show-side-bar="false"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
      />
    </div>
  </el-dialog>
</template>

<script>
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'

export default {
  name: 'DialogSelector',
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, default: '' },
    rowData: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        onRowDoubleClicked: (event) => {
          this.doSelectRow({ ...event.data })
        },
        pagination: false
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Note'),
          field: 'templateDescribe',
          width: 160
        }, {
          headerName: this.$t('CargoMsg.Cargo_Parter'),
          field: 'shortName',
          width: 140
        }, {
          headerName: this.$t('SeaExport.SendAisle'),
          field: 'sendType',
          width: 120,
          cellRenderer: params => {
            const target = params.value ? ChargeItemTarget.getChargeItemTargetByCode2(params.value) : null
            return target ? target.chineseName : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          width: 220
        }
      ]
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    toSelectRow() {
      const self = this
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length !== 1) {
          self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        } else {
          this.doSelectRow(getGridSelected(this.gridOptions)[0])
        }
      })
    },
    doSelectRow(row) {
      this.$emit('selected', row)
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss">
.edi-selector-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>
